import { Component, OnInit } from '@angular/core';
import {CertificadosService} from '../services/certificados.service';
import {InicioFaces} from '../interfaces/inicioFaces';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { AlertsService } from 'angular-alert-module';

@Component({
  selector: 'app-certificados',
  templateUrl: './certificados.component.html',
  styleUrls: ['./certificados.component.css']
})
export class CertificadosComponent implements OnInit {

certificados: [];
desprendibles: [];
 pdfSrc = ""; 

  API_ENDPOINT: string ='http://'+window.location.hostname+':3001';

  constructor(private CertificadosService: CertificadosService,private httpClient: HttpClient,private formBuilder: FormBuilder, private alerts: AlertsService) { }

ngOnInit() {
  console.log('usuario:',localStorage.getItem('currentUser'));
this.listaCertificados();
this.listarDesprendibles();

  }
listaCertificados(){
var currentUser = JSON.parse(localStorage.getItem('currentUser'));
var _this= this;

     this.CertificadosService.listarCertificados(currentUser.documento_id).subscribe((data: any) => {

     console.log('La respuesta es: ', data);
     _this.certificados = data.obj.id;
     console.log(_this.certificados);
     return false
    },
    (error) => {
        alert('Ocurrio un Error');
    });	
	
}

listarDesprendibles(){
var currentUser = JSON.parse(localStorage.getItem('currentUser'));
var _this= this;

     this.CertificadosService.listarDesprendibles(currentUser.documento_id).subscribe((data: any) => {
     _this.desprendibles = data.obj.id;
     console.log(_this.desprendibles);
     return false
    },
    (error) => {
        alert('Ocurrio un Error');
    });	
	
}

    goToLink(pdf: string){
    let url = this.API_ENDPOINT +"/" +pdf;
    	console.log('URL AQUITA',pdf);
        window.open(url, "_blank");
    }
 
  

}
